import { Component, OnDestroy, Input, OnInit, AfterViewInit, ViewChild, Output, EventEmitter } from "@angular/core";
import { Subject } from "rxjs";
import { DialogService, UserAuth } from "@nrwl/common-lib";
import { IValueChangedEvent } from "../../../wizard.content";
import { filter, forEach } from 'lodash';
@Component({
  selector: "wizard-user-to-group",
  templateUrl: "./user.to.group.html",
  providers: [
  ],
  styleUrls: ["../wizard.user.style.scss"]
})
export class UserToGroupComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  wizardService: any;
  dialogService: DialogService;
  selectedAll: any;
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  private unsubscribe: Subject<void> = new Subject();
  constructor() {

  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.wizardService = this.wizardCtrl.wizardService;
    this.wizardService.editMode = true;
    this.selectedAll = {
      isChecked: false
    }
  }

  flipValue(group) {
    if (!group.disabled) {
      this.selectGroup(group);
    }
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupIds',
      newValue: filter(this.step.dataSource, { isChecked: true }),
      isValid: true
    });
    
  }

  flipValues() {
    this.selectedAll.isChecked = !this.selectedAll.isChecked;
    this.selectAllGroup();
    this.onDataValueChange.emit({
      componentId: 'add_users_to_groups',
      key: 'groupIds',
      newValue: filter(this.step.dataSource, { isChecked: true }),
      isValid: true
    });
  }
  selectAllGroup() {
    forEach(this.step.dataSource, (item: any) => {
      item.isChecked = this.selectedAll.isChecked;
    });
  }

  selectGroup(group) {
    group.isChecked = !group.isChecked;
    this.selectAllGroupValue();
  }

  selectAllGroupValue() {
    const data = filter(this.step.dataSource, { isChecked: true });
     this.selectedAll.isChecked = false;
    if (data.length === this.step.dataSource.length) {
      this.selectedAll.isChecked = true;
    }
  }

  clickDetected(event) {
    return false;
  }

  isLoading() {
    return this.wizardService.isLoading;
  }
  
}
